<head>
    <link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
    <style>
        html {
            scroll-behavior: smooth;
        }
        
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    
    </style>
</head>
<div class="h-screen grid place-items-center">
    <div>
        <h1 class="text-white text-9xl font-semibold">404 Not Found :(</h1>
        <div class="flex flex-wrap">
            <a href="https://fyrehost.net" class="w-5/12 mx-auto">
                <div class="bg-indigo-600 p-6 rounded-lg text-3xl text-white text-center mt-10 font-semibold">
                    Homepage
                </div>
            </a>
            <a href="https://panel.fyrehost.net" class="w-5/12 mx-auto">
                <div class="bg-indigo-600 p-6 rounded-lg text-3xl text-white text-center mt-10 font-semibold">
                    Panel
                </div>
            </a>

        </div>
    </div>
</div>
